import * as React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Col, Row } from 'antd';
import { TSearchItemCard } from './definitions';
import Styles from './SearchItemCard.module.scss';
import Text from 'Pages/Home/Components/Atoms/Text';
import Image from 'Pages/Home/Components/Atoms/Image';
import { useHistory } from 'react-router';
import { getHighlightedText } from 'Pages/Home/Helper/Element';
import { handleCategoryTextConverterInvert } from 'helpers/textConverter';

export default function SearchItemCard({
  name,
  image,
  brand,
  slug,
  category,
  afterClick,
  highlightText,
}: TSearchItemCard) {
  const history = useHistory();

  const handleClick = () => {
    history.push(`/${handleCategoryTextConverterInvert(category)}/${brand}/${slug}?from=search`);
    if (afterClick) afterClick();
  };

  return (
    <Col className={Styles['search-item-card']} onClick={handleClick}>
      <Row align="middle">
        <Image src={image} className={Styles['search-item-card-image']} />
        <Text
          className={Styles['search-item-card-title']}
          ellipsis={{
            rows: 2,
            expandable: false,
          }}
        >
          {getHighlightedText(name, highlightText)}
        </Text>
      </Row>
    </Col>
  );
}
